import React, {useEffect, useState} from "react"; 
import { Card, CardStandardHeader } from "@coherence-design-system/card";
import { FontIcon } from "@fluentui/react";
import "../../index.css";

interface IProps {
  title: string;
  children: any;
  isExpandDefault:any;
  onAccordianChange?:any;
  onExpand?: () => void; // Add onExpand prop
  onCollapse?: () => void; // Add onCollapse prop
} 

const Accordion = (props: IProps) => { 
  const [isActive, setIsActive] = useState(false);
   
  useEffect(() => {  
    setIsActive(props.isExpandDefault?true:false);
  }, []);

  useEffect(() => {  
    setIsActive(props.isExpandDefault?true:false);
  }, [props.isExpandDefault]);
  
  const onCardClick = () => {
    setIsActive(!isActive);  
   if (props.onAccordianChange) {
      props.onAccordianChange(isActive, props.title);
   }
   if (!isActive && props.onExpand) {
    props.onExpand(); // Call onExpand when expanding
  }
  if (isActive && props.onCollapse) {
    props.onCollapse(); // Call onCollapse when collapsing
  }
};

    const onHeaderKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onCardClick();
        }
    };

  return ( 
    <div style={{width:"auto", height: isActive? 'auto':"39px",paddingBottom:20 }}>
          <Card header={<div
              role="button"
              tabIndex={0}
              aria-expanded={isActive}
              aria-label={`${isActive ? "Collapse" : "Expand"} ${props.title}`}
              onClick={onCardClick}
              onKeyDown={onHeaderKeyDown}
              style={{ cursor: "pointer" }}
          ><CardStandardHeader cardTitle={props.title} styles={{ root: { borderBottom: '1px solid #edebe9' } }} contextProps={{customButton: <FontIcon aria-hidden={true} iconName={isActive ? 'ChevronUpMed' : 'ChevronDownMed'} style={{ color: 'inherit', margin: '0px 4px', height: '40px', width: '40px', lineHeight: '40px', textAlign: 'center' }} />}}/> </div>}>
        <div style={{ display:isActive ? 'block' : 'none' }}>
        {props.children} 
        </div>
      </Card> 
    </div> 
  );
};  
  
export default Accordion;
